<template>
  <v-flex
    xs12
    sm6
    md6>
    <v-label>Created between dates</v-label>

    <v-menu
      ref="transfersFromMenu"
      v-model="transfersFromMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="transfersDateFrom"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="transfersDateFrom"
          :label="datePickerLabelStart"
          prepend-icon="event"
          readonly
          clearable
          v-on="on"
          @click:clear="clearDate('from')"
        />
      </template>
      <v-date-picker
        v-model="transfersDateFrom"
        no-title
        scrollable>
        <v-spacer/>
        <v-btn
          flat
          color="primary"
          @click="transfersFromMenu = false">{{ 'krita.cancel' | translate }}</v-btn>
        <v-btn
          class="primary"
          color="primary"
          @click="filterTransfersFrom">{{ 'krita.ok' | translate }}</v-btn>
      </v-date-picker>
    </v-menu>

    <v-menu
      ref="transfersToMenu"
      v-model="transfersToMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="transfersToDate"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="transfersToDate"
          :label="datePickerLabelEnd"
          prepend-icon="event"
          readonly
          clearable
          v-on="on"
          @click:clear="clearDate('to')"
        />
      </template>
      <v-date-picker
        v-model="transfersToDate"
        no-title
        scrollable
        color = "primary">
        <v-spacer/>
        <v-btn
          flat
          color="primary"
          @click="transfersToMenu = false">{{ 'krita.cancel' | translate }}</v-btn>
        <v-btn
          color="primary"
          class="primary"
          @click="filterTransfersTo">{{ 'krita.ok' | translate }}</v-btn>
      </v-date-picker>
    </v-menu>
    <div id="transfersFilter">
      <v-btn
        :class="{ secondary: transfersSelection === 'factoringTransfers' }"
        selection="factorings"
        color="#3357A0"
        @click="$emit('filterTransfers','factoringTransfers')">{{ 'krita.transfers.factorings' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: transfersSelection === 'applicationTransfers' }"
        selection="applications"
        color="#3357A0"
        @click="$emit('filterTransfers','applicationTransfers')">{{ 'krita.transfers.applications' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: transfersSelection === 'repayments' }"
        selection="repayments"
        color="#3357A0"
        @click="$emit('filterTransfers','repayments')">{{ 'krita.transfers.repayments' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: transfersSelection === 'all' }"
        selection="all"
        color="#3357A0"
        @click="$emit('filterTransfers','all')">{{ 'krita.transfers.all' | translate }}</v-btn>
    </div>
  </v-flex>
</template>

<script>
    export default {
        name: "TransfersControllers",
        props: ['transfersSelection'],
        data ()
        {
            return {
                datePickerLabelStart: this.$t('krita.datepick.startdate'),
                datePickerLabelEnd: this.$t('krita.datepick.enddate'),
                transfersDateFrom: null,
                transfersFromMenu: false,
                transfersToDate: null,
                transfersToMenu: false
            }
        },
        methods: {
            clearDate(target)
            {
                let self = this;

                switch (target) {
                    case 'from':
                        self.transfersDateFrom = null;
                        break;
                    case 'to':
                        self.transfersToDate = null;
                        break;
                }
                self.$emit('clearDate', target);
            },
            filterTransfersFrom ()
            {
                let self = this;
                self.$refs.transfersFromMenu.save(self.transfersDateFrom);
                self.transfersFromMenu = false;
                self.$emit('filterTransfersFrom',self.transfersDateFrom)
            },
            filterTransfersTo ()
            {
                let self = this;
                self.$refs.transfersToMenu.save(self.transfersToDate);
                self.transfersToMenu = false;
                self.$emit('filterTransfersTo',self.transfersToDate)
            }
        }
    }
</script>

<style scoped>

</style>
